/* dm-es-popup.js · popup de cupón -10 % de drmartens.com/es/es (snippets/dm-es-signup-popup.liquid · assets/dm-es-popup.css).
   En España es un formulario de Klaviyo (cuenta U8Jt5U: «ES Desktop Popup - WBS» QVTPBm / «ES Mobile Popup - WBS» XTJAKC).
   Lo que se porta de su configuración pública (static-forms.klaviyo.com/forms/api/v7/U8Jt5U/full-forms) y de su JS onsite:
     · variante por dispositivo = la de Klaviyo: regex de user-agent de detectmobilebrowsers (sharedUtils, módulo 29410);
       teléfono → formulario de 600 px con la foto arriba; resto (escritorio, tablet) → 780 px con la foto a la izquierda
     · escala = mín(1, ancho del documento / (ancho del formulario + 40)); si achica, márgenes laterales −ancho·(1−escala)/2 y
       max-height (100/escala) % (Render.js de Klaviyo, tipo POPUP); se recalcula al cambiar el tamaño de la ventana
     · disparador DELAY 15 s en la página (Klaviyo cuenta elapsedTimeOnCurrentPage desde que arranca, y en España arranca después
       del evento load); no se muestra a perfiles ya identificados en Klaviyo (EXISTING_USER), ni tras suscribirse
       (SUPPRESS_SUCCESS_FORM), ni durante 5 días después de cerrarlo (COOKIE_TIMEOUT 5)
     · entrada klaviyo-fadein 0,35 s ease · salida klaviyo-fadeout 0,35 s · foco al abrir: X en escritorio, correo en celular ·
       Tab circular dentro del popup · Escape cierra · clic en el fondo cierra en escritorio, en celular no (ignore_overlay_dismissal)
     · validación: correo obligatorio y válido, nombre obligatorio; aviso en globo bajo el campo con role=alert
   Propio de acá (decisiones del encargo, no de España):
     · no se muestra en carrito, cuenta, páginas de newsletter/preguntas frecuentes, en el editor de temas, ni encima de otro diálogo
       o menú abierto (espera a que se cierren) ni mientras se está escribiendo en otro campo
     · envío directo a la lista del popup anterior por la API cliente de Klaviyo (POST /client/subscriptions); el consentimiento lo da la relación con la lista: el campo «subscriptions» NO existe en la API cliente y daba 400 (bug visto el 16-oct-2026) y, si está el script
       de Klaviyo, klaviyo.identify con el correo → sigue saliendo el mail con el código
     · apaga el popup de Klaviyo del tema anterior (formularios TtWmrC · SdUgcn · QZCD4R): CSS lo oculta y acá se cierra con su X
     · (17-oct-2026, pedido del user) se cierra con la cruz, con Escape y tocando afuera del recuadro, en celular y en escritorio */
(() => {
  'use strict';
  const host = document.querySelector('[data-dm-es-popup]');
  const cfg = host ? host.dataset : {};

  /* ── 1 · popup de Klaviyo del tema anterior: se cierra con su propia X apenas se abre (Klaviyo guarda el cierre y no
         vuelve a intentarlo en 5 días). El CSS (dm-es-popup.css §0) ya lo dejó oculto, así que no parpadea. ── */
  const OLD = (cfg.dmKlaviyoOld || 'TtWmrC,SdUgcn,QZCD4R').split(',').map(s => s.trim()).filter(Boolean);
  const OLD_SEL = OLD.map(id => `form[data-testid="klaviyo-form-${id}"]`).join(',');
  const releaseBody = () => {
    // si no queda ningún modal de Klaviyo a la vista, se libera el scroll (mismo arreglo que usa España cuando apaga los popups de Klaviyo)
    const visible = [...document.querySelectorAll('[role="dialog"][aria-modal="true"]')].some(d => d.querySelector('.klaviyo-form') && d.getClientRects().length && getComputedStyle(d).visibility !== 'hidden');
    if (!visible) document.body.classList.remove('klaviyo-prevent-body-scrolling');
  };
  // aprieta la X de cada popup viejo que esté abierto (y no saliendo ya); devuelve si queda alguno abierto
  const sweepOld = () => {
    let open = false;
    document.querySelectorAll(OLD_SEL).forEach(f => {
      const d = f.closest('[role="dialog"]');
      if (!d || /klaviyo-fadeout/.test(d.getAttribute('style') || '')) return;
      open = true;
      const x = d.querySelector('button.klaviyo-close-form, button[aria-label]');
      if (x && (!d.__dmClick || Date.now() - d.__dmClick > 1200)) { d.__dmClick = Date.now(); x.click(); }
    });
    return open;
  };
  // tras el evento «open» Klaviyo tarda un poco en dibujarlo (más en celular): se revisa cada 150 ms hasta que salga (máx. 30 s)
  let oldTimer = 0;
  const watchOld = () => {
    if (oldTimer) return;
    const t0 = Date.now(); let seen = false;
    oldTimer = setInterval(() => {
      const open = sweepOld(); if (open) seen = true;
      if ((seen && !open) || Date.now() - t0 > 30000) { clearInterval(oldTimer); oldTimer = 0; setTimeout(releaseBody, 600); }
    }, 150);
  };
  window.addEventListener('klaviyoForms', e => {
    const d = (e && e.detail) || {};
    if (d.type === 'open' && OLD.includes(d.formId)) watchOld();
  });
  if (document.querySelector(OLD_SEL)) watchOld();

  if (!host || !cfg.dmCompany || !cfg.dmList) return;

  /* ── 2 · ¿corresponde mostrarlo? ── */
  const K_CLOSED = 'dm-es-popup:cerrado', K_DONE = 'dm-es-popup:suscrito';
  const lsGet = k => { try { return window.localStorage.getItem(k); } catch (e) { return null; } };
  const lsSet = (k, v) => { try { window.localStorage.setItem(k, v); } catch (e) { /* sin almacenamiento: no pasa nada */ } };
  const DAYS = Number(cfg.dmDays) || 5, DELAY = (Number(cfg.dmDelay) || 15) * 1000;
  // el alta por el newsletter del footer o de la página vuelve de Shopify con ?customer_posted=true: cuenta como suscrito
  try { if (new URLSearchParams(window.location.search).get('customer_posted') === 'true' || (document.querySelector('[data-dm-newsletter-result]') || {}).value === 'success') lsSet(K_DONE, String(Date.now())); } catch (e) { /* URL rara */ }
  const blocked = () => {
    if (lsGet(K_DONE)) return true;
    const closed = Number(lsGet(K_CLOSED)) || 0;
    return closed > 0 && Date.now() - closed < DAYS * 864e5;
  };
  const pt = cfg.dmPageType || '', path = window.location.pathname.toLowerCase();
  const excludedPage = /^(cart|customers\/|password|gift_card|captcha)/.test(pt)
    || /\/(cart|checkouts?|account|challenge)(\/|$)/.test(path)
    || /\/pages\/[^/]*(newsletter|preguntas-frecuentes|faq)/.test(path);
  const designMode = !!(window.Shopify && window.Shopify.designMode);
  if (excludedPage || designMode || blocked()) return;

  // EXISTING_USER de Klaviyo: perfil ya identificado en este navegador (vino de un mail, ya se suscribió, etc.)
  const klaCookie = () => {
    try {
      const m = document.cookie.match(/(?:^|;\s*)__kla_id=([^;]+)/);
      if (!m) return false;
      const j = JSON.parse(window.atob(decodeURIComponent(m[1])));
      return !!(j && (j.$exchange_id || j.$email || j.$phone_number));
    } catch (e) { return false; }
  };
  const identified = () => new Promise(resolve => {
    if (klaCookie()) return resolve(true);
    const k = window.klaviyo;
    if (!k || typeof k.isIdentified !== 'function') return resolve(false);
    let done = false; const end = v => { if (!done) { done = true; resolve(!!v); } };
    setTimeout(() => end(false), 1500);
    try { Promise.resolve(k.isIdentified()).then(end, () => end(false)); } catch (e) { end(false); }
  });

  // variante como Klaviyo: user-agent de teléfono (detectmobilebrowsers.com, igual que su sharedUtils)
  const UA = navigator.userAgent || navigator.vendor || window.opera || '';
  const MOBILE = window.klaviyoForceMobile || /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(UA)
    || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(UA.substr(0, 4));
  const FORM_W = MOBILE ? 600 : 780, FRAME_W = FORM_W + 40;
  const SRC = MOBILE ? cfg.dmSrcM : cfg.dmSrcD;

  /* ── 3 · que no tape otra cosa: menú/panel/diálogo abierto, otro modal de Klaviyo, o alguien escribiendo ── */
  const busy = () => {
    if (document.querySelector('dialog[open]')) return true;
    if (document.body.classList.contains('klaviyo-prevent-body-scrolling')) return true;
    const a = document.activeElement;
    if (a && a !== document.body && (a.matches('input:not([type=checkbox]):not([type=radio]):not([type=button]):not([type=submit]), textarea, select, [contenteditable="true"]'))) return true;
    return false;
  };
  const whenFree = fn => {
    if (!busy()) return fn();
    const iv = setInterval(() => {
      if (busy()) return;
      clearInterval(iv);
      setTimeout(() => (busy() ? whenFree(fn) : fn()), 600);
    }, 800);
  };

  /* ── 4 · abrir / cerrar ── */
  let root = null, lastFocus = null, sent = false, onResize = null, onKey = null;
  const $ = (s, r = root) => (r ? r.querySelector(s) : null);
  const tpl = n => { const t = host.querySelector(`template[data-dm-popup-tpl="${n}"]`); return t ? t.content : null; };
  const lock = on => {
    const L = window.DMES && window.DMES.scrollLock;
    if (L) { on ? L.add('dm-es-popup') : L.remove('dm-es-popup'); return; }
    document.documentElement.style.overflow = on ? 'hidden' : '';
  };
  const focusables = () => [...root.querySelectorAll('button:not([disabled]), [href], input:not([type="hidden"]):not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])')].filter(e => e.getClientRects().length);
  const layout = () => {
    if (!root) return;
    const frame = $('[data-dm-popup-frame]');
    const vw = document.documentElement.clientWidth || window.innerWidth;
    const s = Math.min(vw / FRAME_W, 1);
    frame.style.transform = `scale(${s})`;
    frame.style.maxHeight = `${100 / s}%`;
    const m = s < 1 ? `${-(FRAME_W * (1 - s)) / 2}px` : '';
    frame.style.marginLeft = m; frame.style.marginRight = m;
  };
  const fillImages = scope => { scope.querySelectorAll('img[data-dm-popup-img]').forEach(img => { if (SRC && !img.getAttribute('src')) img.setAttribute('src', SRC); }); };

  const close = () => {
    if (!root || root.hasAttribute('data-dm-closing')) return;
    if (!sent) lsSet(K_CLOSED, String(Date.now()));
    const r = root;
    r.setAttribute('data-dm-closing', '');
    const done = () => {
      if (!r.isConnected) return;
      r.remove(); root = null;
      lock(false);
      window.removeEventListener('resize', onResize); document.removeEventListener('keydown', onKey, true);
      if (lastFocus && lastFocus.isConnected && typeof lastFocus.focus === 'function') { try { lastFocus.focus({ preventScroll: true }); } catch (e) { /* nada */ } }
    };
    const d = $('[data-dm-popup-dialog]', r);
    d.addEventListener('animationend', done, { once: true });
    setTimeout(done, 600);   // por si el navegador no dispara animationend (pestaña oculta, animaciones apagadas)
  };

  const show = () => {
    if (root || blocked()) return;
    const content = tpl(MOBILE ? 'mobile' : 'desktop');
    if (!content) return;
    root = content.firstElementChild.cloneNode(true);
    fillImages(root);
    host.appendChild(root);
    layout();
    onResize = () => layout(); window.addEventListener('resize', onResize);
    lastFocus = document.activeElement;
    lock(true);

    // foco como Klaviyo: primer elemento enfocable (la X); en celular, el primer campo
    const first = MOBILE ? $('[data-dm-popup-email]') : $('[data-dm-popup-close]');
    try { first.focus({ preventScroll: true }); } catch (e) { /* nada */ }

    onKey = e => {
      if (!root) return;
      if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); close(); return; }
      if (e.key !== 'Tab') return;
      const f = focusables(); if (!f.length) return;
      const a = f[0], z = f[f.length - 1];
      if (!root.contains(document.activeElement)) { e.preventDefault(); a.focus({ preventScroll: true }); return; }
      if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus({ preventScroll: true }); }
      else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus({ preventScroll: true }); }
    };
    document.addEventListener('keydown', onKey, true);

    // Cierre (pedido del user 17-oct-2026, reemplaza la regla del 16-oct de «solo la cruz»): la cruz, Escape y también un toque o clic
    // AFUERA del recuadro, en celular y en escritorio. Solo cuenta si el toque empieza y termina afuera (arrastrar desde un campo del
    // formulario hasta el fondo no lo cierra). España cerraba afuera solo en escritorio (en celular, ignore_overlay_dismissal).
    let downOutside = false;
    root.addEventListener('pointerdown', e => { downOutside = !e.target.closest('[data-dm-popup-box]'); });
    root.addEventListener('click', e => {
      if (e.target.closest('[data-dm-popup-close], [data-dm-popup-close-on-click]')) { close(); return; }
      if (downOutside && !e.target.closest('[data-dm-popup-box]')) close();
    });
    wireForm();
  };

  /* ── 5 · formulario: validación como Klaviyo y envío a la lista del país ── */
  const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  const errTpl = tpl('error');
  const setError = (input, msg) => {
    const box = input.parentElement.querySelector('.es-signup-popup__fieldMsg');
    box.textContent = '';
    if (!msg) { input.setAttribute('aria-invalid', 'false'); input.removeAttribute('aria-describedby'); return; }
    const tip = errTpl.firstElementChild.cloneNode(true);
    const txt = tip.querySelector('[role="alert"]');
    txt.id = `${input.id}-error`; txt.textContent = msg;
    box.appendChild(tip);
    input.setAttribute('aria-invalid', 'true'); input.setAttribute('aria-describedby', txt.id);
  };
  const check = (input, isEmail) => {
    const v = input.value.trim();
    if (!v) return cfg.dmTRequired;
    if (isEmail && (v.length > 254 || !EMAIL_RE.test(v))) return cfg.dmTInvalid;
    return '';
  };
  const wireForm = () => {
    const form = $('[data-dm-popup-form]'), email = $('[data-dm-popup-email]'), name = $('[data-dm-popup-name]'), btn = $('[data-dm-popup-submit]');
    let tried = false;
    [[email, true], [name, false]].forEach(([inp, isEmail]) => inp.addEventListener('input', () => { if (tried && inp.getAttribute('aria-invalid') === 'true') setError(inp, check(inp, isEmail)); }));
    form.addEventListener('submit', async e => {
      e.preventDefault();
      if (btn.hasAttribute('data-dm-loading')) return;
      tried = true;
      const eErr = check(email, true), nErr = check(name, false);
      setError(email, eErr); setError(name, nErr);
      if (eErr || nErr) { (eErr ? email : name).focus({ preventScroll: true }); return; }
      const mail = email.value.trim(), first = name.value.trim();
      btn.setAttribute('data-dm-loading', ''); btn.disabled = true;
      const ctl = 'AbortController' in window ? new AbortController() : null;
      const timer = setTimeout(() => ctl && ctl.abort(), 15000);
      try {
        const res = await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(cfg.dmCompany)}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
          body: JSON.stringify({ data: { type: 'subscription', attributes: {
            custom_source: cfg.dmSource || 'Popup sitio nuevo',
            profile: { data: { type: 'profile', attributes: { email: mail, first_name: first } } } },
            relationships: { list: { data: { type: 'list', id: cfg.dmList } } } } }),
          signal: ctl ? ctl.signal : undefined,
        });
        if (!res.ok) throw new Error(`klaviyo ${res.status}`);
        sent = true;
        lsSet(K_DONE, String(Date.now()));
        try { if (window.klaviyo && typeof window.klaviyo.identify === 'function') window.klaviyo.identify({ email: mail, first_name: first }); } catch (err) { /* sin el script de Klaviyo: no pasa nada */ }
        success();
      } catch (err) {
        btn.removeAttribute('data-dm-loading'); btn.disabled = false;
        setError(email, cfg.dmTFail);
      } finally { clearTimeout(timer); }
    });
  };
  const success = () => {
    if (!root) return;
    const box = $('[data-dm-popup-content]');
    const ok = tpl(MOBILE ? 'ok-mobile' : 'ok-desktop');
    box.replaceChildren(ok.cloneNode(true));
    fillImages(box);
    const title = box.querySelector('strong');
    const ann = $('[data-dm-popup-announcer]');
    if (ann && title) ann.textContent = title.textContent;
    const x = $('[data-dm-popup-close]');
    try { x.focus({ preventScroll: true }); } catch (e) { /* nada */ }
  };

  /* ── 6 · disparador: 15 s en la página contados desde que terminó de cargar (como Klaviyo en España) ── */
  const arm = () => {
    const go = () => {
      if (SRC) { const pre = new Image(); pre.decoding = 'async'; pre.src = SRC; }   // la foto ya está lista cuando aparece
      setTimeout(async () => {
        if (blocked() || await identified()) return;
        whenFree(show);
      }, DELAY);
    };
    if ('requestIdleCallback' in window) window.requestIdleCallback(go, { timeout: 2000 }); else setTimeout(go, 1);
  };
  if (document.readyState === 'complete') arm(); else window.addEventListener('load', arm, { once: true });

  // para QA (la consola): DMESPopup.open() lo abre sin esperar · DMESPopup.reset() borra las marcas de cerrado/suscrito
  window.DMESPopup = { open: () => whenFree(show), close, reset: () => { try { localStorage.removeItem(K_CLOSED); localStorage.removeItem(K_DONE); } catch (e) { /* nada */ } } };
})();
